<div #templateOutlet class="homr-banner-content"></div>
